import { render, staticRenderFns } from "./ProFooterSection.vue?vue&type=template&id=52482ae6&"
import script from "./ProFooterSection.vue?vue&type=script&lang=js&"
export * from "./ProFooterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports